import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import { useNavigate, useLocation } from 'react-router-dom';
import apiService from '../../../utlis/apiService';
import { ArrowBackIos as BackButton } from '@mui/icons-material';
import Students from './getStudents'
import Materials from './uploadMaterial'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat'; // Import the advancedFormat plugin
import 'dayjs/locale/en';
import Schdule from './manageSchedule';
import ManageExam from './manageExam';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ActivityLogs from './log'
import { useUser } from '../../../context/userContext';
import { generateYearRange, getMode, getSessions, getStatusType } from '../../../utlis/commonFunction';
import { debounce } from "lodash";
import axios from 'axios';
import { elantUrl, partnerId } from '../../../config';

dayjs.extend(AdvancedFormat);

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const CreatebatchForm = () => {
  const query = useQuery();
  const id = query.get("id");
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    nameTail: '',
    branch:'',
    course:'',
    mentor:'',
    faculty:'',
    coordinator: '',
    year:'',
    paper:'',
    limit: '',
    date: null,
    endDate: null,
    status: '',
    statusOptions: [],
    mode: '',
    session: '',
    hours: '',
    consecutiveHours: '',
    draftBatch: '',
    elantGoal: '',
    elantPaper: '',
    elantTutor: '',
    elantExpiry: null,
    zoomMeetingNumber: '',
    zoomMeetingPassword: ''
  });
  const [papers,setPapers]=useState([])
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [exams, setExams] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState('');
  const [statusType, setStatusType] = useState([]);
  const [drafBatches, setDrafBatches] = useState([]);
  const [searchBatch, setSearchBatch] = useState('');
  const [loading, setLoading] = useState(false);
  const [goal, setGoal] = useState([]);
  const [paper, setPaper] = useState([]);
  const [tutor, setTutor] = useState([]);

  const [checklist, setChecklist] = useState([
    { id: 'Board', checked: false },
    { id: 'Projector', checked: false },
    { id: 'TV', checked: false },
  ]);

  const nameExceptionSubjects = [
    'Business and Technology (BT)',
    'Management Accounting (MA)',
    'Financial Accounting (FA)',
    'Corporate and Business Law (LW)',
    'Financial Reporting (FR)',
    'Financial Management (FM)',
    'Taxation (TX)',
    'Performance Management (PM)',
    'BOTH PART'
  ]

  const { permissions } = useUser();
  
  const handleChecklistChange = (index) => {
    setChecklist((prevChecklist) =>
      prevChecklist.map((item, i) => (i === index ? { ...item, checked: !item.checked } : item))
    );
  };

  const fetchbatchData = async () => {
    try {
      const response = await apiService.get(`/batch/get`, {
        params: {
          id: id,
        },
      });
  
      setFormData({ ...response?.data, student: [], exam: []});
      setSelectedStudents(response?.data?.student || []);
      setMaterials(response?.data?.materials);
      setSchedule(response?.data?.schedule);
      setExams(response?.data?.exam);
      getElantSyllabus();
    } catch (error) {
      console.error(error);
    }
  };
  
  useEffect(() => {
    if (id) {
      
      fetchbatchData();
    }
  }, [id]);

  const [errors, setErrors] = useState({
    name: '',
    consecutiveHours: '',
  });

  

  const [branchs, setBranchs]=useState([]);

  const [courses, setCourses]=useState([]);

  const [mentors, setMentors]=useState([]);

  const [faculties, setFaculties]=useState([]);

  // const [classes,setClasses] = useState([])

  const [coordinator, setCoordinator] = useState([]);

  const years = generateYearRange();
  const sessions = getSessions();
  const mode = getMode();

  useEffect(() => {
    getAllData();
    fetchStatusTypeData();
  }, [])

  useEffect(() => {
    const storedFormData = JSON.parse(localStorage.getItem('batchFormData'));
    const storedTimestamp = localStorage.getItem('batchFormDataTimestamp');

    if (storedFormData && isRecent(storedTimestamp)) {
      setFormData(storedFormData);
    }
  }, []);


  useEffect(() => {
    if (formData.course){
      getPapersByCourse(formData.course)
    }
  },[formData.course]);

  const isRecent = (timestamp) => {
    const currentTimestamp = new Date().getTime();
    return currentTimestamp - timestamp < 50000; 
  };

  useEffect(() => {
    if(papers.length > 0) {
      const paperListItem = papers.filter(paper => paper._id === formData.paper);
      setSelectedSubject(paperListItem[0]?.name);
    }
  }, [papers]);

  useEffect(() => {
    fetchBatch(searchBatch);
  }, []);

  const fetchStatusTypeData = async () => {
		const statusTypeData = await getStatusType();
		setStatusType(statusTypeData);
	}

  const getAllData = async () => {
    try {
      const [branchResponse, courseResponse, mentorResponse, facultyResponse, coordinatorResponse] = await Promise.all([
        apiService.get('/branch/list'),
        apiService.get('/course/list'),
        apiService.get('/mentor/list'),
        apiService.get('/faculty/list'),
        // apiService.get('/class/list'),
        apiService.get('/coordinator/list'),
      ]);
  
      const branch = branchResponse?.data?.branchs;
      const course = courseResponse?.data?.course;
      const mentor = mentorResponse?.data?.mentor;
      const faculty = facultyResponse?.data?.faculty;
      // const classs = classResponse?.data?.classRoom;
      const coordinator = coordinatorResponse?.data?.coordinator;
  
      setBranchs(branch);
      setCourses(course);
      setMentors(mentor);
      setFaculties(faculty);
      // setClasses(classs);
      setCoordinator(coordinator);
    } catch (error) {
      console.error('Error during requests:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if(name === 'limit') {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
        oldLimit: prevData.limit
      }));
    }
    else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleBlurLimit = (e) => {
    const { name, value } = e.target;
    if(value < selectedStudents.length) {
      alert("Can't process. The student enrolled count is grater than " + value);
      setFormData((prevData) => ({
        ...prevData,
        [name]: prevData.oldLimit,
      }));
    }
  }

  const handleDateChange = (nName, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [nName]: value,
    }));
  }

  const handleChangeSubmit = (e, value, name) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value?._id,
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      location: '',
      consecutiveHours: '',
    };

    if(selectedStudents.length > formData.limit){
      alert('The selected student exceeds the capacity limit.');
      isValid = false;
    }

    if(!formData.hours) {
      alert('Total required hours is required.');
      isValid = false;
    }

    if(!formData.date) {
      alert('Schedule start after is required.');
      isValid = false;
    }

    if(!formData.endDate) {
      alert('Schedule end before is required.');
      isValid = false;
    }

    if(formData.status === 'Open For Enrollment' && !formData.statusOptions?.length) {
      alert('Select atleast on option for status.');
      isValid = false;
    }
    if(!formData.consecutiveHours) {
      alert('Consecutive Hours is required.');
      isValid = false;
      newErrors.consecutiveHours = 'Consecutive Hours is required';
    }
    if(id) {
      if(!formData.elantGoal) {
        alert('Elant Goal is required.');
        isValid = false;
        newErrors.elantGoal = 'Elant Goal is required';
      }
      if(!formData.elantPaper) {
        alert('Elant Paper is required.');
        isValid = false;
        newErrors.elantPaper = 'Elant Paper is required';
      }
      if(!formData.elantTutor) {
        alert('Elant Tutor is required.');
        isValid = false;
        newErrors.elantTutor = 'Elant Tutor is required';
      }
      if(!formData.elantExpiry) {
        alert('Elant Expiry is required.');
        isValid = false;
        newErrors.elantExpiry = 'Elant Expiry is required';
      }

      if(formData.mode === 'Online') {
        if(!formData.zoomMeetingNumber) {
          alert('Zoom Meeting Number is required.');
          isValid = false;
          newErrors.zoomMeetingNumber = 'Zoom Meeting Number is required';
        }
        if(!formData.zoomMeetingPassword) {
          alert('Zoom Meeting Password is required.');
          isValid = false;
          newErrors.zoomMeetingPassword = 'Zoom Meeting Password is required';
        }
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (validateForm()) {
      const apiUrl = id ? `/batch/update?id=${id}` : '/batch/create';
  
      try {
        const response = await apiService.post(apiUrl, { ...formData, materials });
        navigate(-1);
        console.log(JSON.stringify(response.data));
      } catch (error) {
        alert(error?.response?.data?.error);
        console.error(error);
      }
    }
  
  };

  const onChangeStudent=(newValue)=>{
    if(newValue.length > formData.limit)
      alert('Maximum batch capacity reached!');
    else
      setSelectedStudents(newValue);
  }

  const handleChangeYear=(name, value)=>{
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }

  const handleChangeList = (name, value) => {
    // alert(value?._id)
    setFormData((prevData) => ({
      ...prevData,
      [name]: value?._id,
    }));

    if(name === 'paper') {
      setSelectedSubject(value?.name);
    }
  };

  const getPapersByCourse=async(cid)=>{
    try {
      const response = await apiService.get(`/paper/paperbycourse?id=${cid}`);
      setPapers(response.data)
    } catch (error) {
      // alert(error?.response?.data?.error);
      console.error(error);
    }
  }

  const createOnClick=(loc)=>{
      localStorage.setItem('batchFormData', JSON.stringify(formData));
      localStorage.setItem('batchFormDataTimestamp', new Date().getTime());
      navigate(`/${loc}/add`)
  }

  const handleStatusOptionChange = (e, type) => {
    if(e.target.checked) {
      if(type === 'All'){
        setFormData((prevData) => ({
          ...prevData,
          statusOptions: statusType,
        }));
      }
      else {
        setFormData((prevData) => ({
          ...prevData,
          statusOptions: [...prevData.statusOptions, type]
        }));
      }
    }
    else {
      if(type === 'All'){
        setFormData((prevData) => ({
          ...prevData,
          statusOptions: [],
        }));
      }
      else {
        setFormData((prevData) => ({
          ...prevData,
          statusOptions: prevData.statusOptions.filter(option => option !== type),
        }));
      }
    }
  }

  const fetchBatch = async (query) => {
    try {
      setLoading(true);
      const response = await apiService.get('/draft-batch/list', {
        params: {
            searchTerm: query,
            type: 'batch'
        },
      });

      setDrafBatches(response?.data?.batchs ?? []);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchBatch = debounce((query) => {
    fetchBatch(query);
  }, 300);

  const handleSearchBatchOptionChange = (e, newQuery) => {
    if(e?.target?.value) {
        setSearchBatch(e?.target?.value);
        debouncedFetchBatch(newQuery);
    }
  }

  const addStudentFromDraft = async () => {
    try {
      setLoading(true);
      const data = {
        batchId: id,
        draftBatchId: formData.draftBatch,
      }
      const response = await apiService.post('/batch/add-student/from-draft', data);

      fetchbatchData();

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const getElantSyllabus = async () => {
    try {
        const response = await axios.get(`${elantUrl}/syllabus`, {
            params: {
                partner_id: partnerId,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Basic dXNlcjpwYXNzd29yZA==",
            },
            auth: {
                username: 'user',
                password: 'password'
            }
        });

        setGoal(response.data);
        if(id && formData.elantGoal) {
          const currentGoals = response.data.find(goal => goal._id === formData.elantGoal) ?? null;
          setPaper(currentGoals?.papers);

          if(formData.elantPaper) {
            const currentPapers = currentGoals?.papers?.find(paper => paper.paper_id === formData.elantPaper) ?? null;
            setTutor(currentPapers?.tutors);
          }
        }
    } catch (error) {
        alert(error);
        console.error(error);
    }
  }

  const handleChangeGoal = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      elantGoal: value?._id,
      elantPaper: '',
      elantTutor: '',
    }));

    setPaper(value.papers);
  }

  const handleChangePaper = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      elantPaper: value.paper_id,
      elantTutor: '',
    }));

    setTutor(value.tutors);
  }

  const handleChangeTutor = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      elantTutor: value.tutor_id,
    }));
  }

  useEffect(() => {
      getElantSyllabus();
  }, [formData.elantGoal, formData.elantPaper]);

  return (
    <div>
      <h1 style={{ cursor: 'pointer', width: 'fit-content' }} onClick={() => navigate(-1)}>
        <BackButton/>
        {`Batches`}
      </h1>
      <form onSubmit={handleSubmit}>
        <Typography variant="h4" gutterBottom>
          {id ? 'Edit' : 'Create'} Batch
        </Typography>
        {/* {nameExceptionSubjects.includes(selectedSubject) && permissions.includes('updateNameTail') ?  */}
          <TextField
            label="Name Tail"
            name="nameTail"
            value={formData.nameTail}
            onChange={handleChange}
            fullWidth
            sx={{marginTop:'40px'}}
            margin="normal"
            size="small"
          />  
        {/* : ''
        } */}
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          name="year"
          required
          options={years}
          style={{ marginTop: 15 }}
          getOptionLabel={(option) => option}  
          value={formData.year || null}
          onChange={(e, value) => handleChangeYear('year', value)} 
          renderInput={(params) => <TextField {...params} label="Academic Year" />}
          size="small"
        />
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          name="session"
          required
          options={sessions}
          style={{ marginTop: 15 }}
          getOptionLabel={(option) => option}  
          value={formData.session || null}
          onChange={(e, value) => handleChangeYear('session', value)} 
          renderInput={(params) => <TextField {...params} label="Session" />}
          size="small"
        />
        <div style={{textAlign:'right'}}>
        <Typography  gutterBottom style={{margin: '10px 0', fontSize:13, color:'#1876d2',cursor:'pointer', width: 'fit-content', float: 'right'}} onClick={()=>createOnClick('dashboard/branch')}>
          + create branch
        </Typography>
        </div>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          name="branch"
          options={branchs}
          style={{ marginTop: "20px" }}
          getOptionLabel={(option) => option.name}
          value={branchs.find((option) => option._id === formData.branch) || null}
          onChange={(e, value) => handleChangeList('branch', value)} 
          renderInput={(params) => <TextField {...params} label="Branch" />}
          size="small"
        />

        <div style={{textAlign:'right',marginTop:10}}>
        <Typography  gutterBottom style={{margin: '10px 0', fontSize:13,color:'#1876d2',cursor:'pointer', width: 'fit-content', float: 'right'}} onClick={()=>createOnClick('dashboard/class')}>
          + create class room
        </Typography>
        </div>

        <Autocomplete
          disablePortal
          id="combo-box-demo"
          name="courses"
          options={courses}
          style={{ marginTop: "20px" }}
          getOptionLabel={(option) => option.name}
          value={courses.find((option) => option._id === formData.course) || null}
          onChange={(e, value) => handleChangeList('course', value)} 
          renderInput={(params) => <TextField {...params} label="Add Course" />}
          size="small"
        />

      {formData.course && (
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          name="paper"
          required
          options={papers}
          style={{ marginTop: 30 }}
          getOptionLabel={(option) => option.name} 
          value={papers.find((option) => option._id === formData.paper) || null}
          onChange={(e, value) => handleChangeList('paper',value)} 
          renderInput={(params) => <TextField {...params} label="Subject" />}
          size="small"
        />
      )}

      <TextField
        label="Capacity"
        name="limit"
        value={formData.limit}
        onChange={handleChange}
        onBlur={handleBlurLimit}
        fullWidth
        required
        sx={{ marginTop:'20px' }}
        margin="normal"
        size="small"
      />

      <TextField
        label="Total Required Hours"
        name="hours"
        value={formData.hours}
        onChange={handleChange}
        fullWidth
        required
        margin="normal"
        size="small"
      />

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <FormControl className='gap-2 mb-8' fullWidth style={{ marginTop: "10px" }} size="small">
          <MobileDatePicker
            label="Schedule Start After"
            value={dayjs(formData.date)}
            onChange={(date) => handleDateChange('date', date)}
            sx={{ marginTop: 1 }}
            slotProps={{
              textField: {
                size: 'small'
              }
            }}
          />
        </FormControl>
      </LocalizationProvider>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <FormControl className='gap-2 mb-8' fullWidth style={{ marginTop: "10px" }} size="small">
          <MobileDatePicker
            label="Schedule End Before"
            value={formData.endDate ? dayjs(formData.endDate) : null}
            onChange={(date) => handleDateChange('endDate', date)}
            sx={{ marginTop: 1 }}
            slotProps={{
              textField: {
                size: 'small'
              }
            }}
          />
        </FormControl>
      </LocalizationProvider>

      <FormControl fullWidth sx={{ marginTop: '20px' }} size="small">
        <InputLabel id="Select Status">Select Status</InputLabel>
        <Select
          label="Select Status"
          value={formData.status}
          onChange={handleChange}
          fullWidth
          name="status"
          size="small"
        >
          <MenuItem value="Upcoming">Upcoming</MenuItem>
          <MenuItem value="Open For Enrollment">Open For Enrollment</MenuItem>
          <MenuItem value="Running">Running</MenuItem>
          <MenuItem value="Completed">Completed</MenuItem>
        </Select>
      </FormControl>

      {formData.status === 'Open For Enrollment' ?
        <Grid container spacing={2} sx={{ marginTop: 1}}>
          <Grid item xs={2}>
            <FormControlLabel control={<Checkbox checked={formData?.statusOptions?.length === statusType?.length} onChange={(e) => handleStatusOptionChange(e, 'All')} />} label="All" />
          </Grid>
          {statusType?.map((type, index) => (
            <Grid item xs={2} key={index}>
              <FormControlLabel control={<Checkbox checked={formData.statusOptions.includes(type)} onChange={(e) => handleStatusOptionChange(e, type)} />} label={type} />
            </Grid>
          ))}
        </Grid>
      : ''}

      <FormControl fullWidth sx={{ marginTop: '20px' }} size="small">
        <InputLabel id="Select Mode">Select Mode</InputLabel>
        <Select
          label="Select Mode"
          value={formData.mode}
          onChange={handleChange}
          fullWidth
          name="mode"
          size="small"
        >
          {mode.map((mode, index) => (
            <MenuItem value={mode} key={index}>{mode}</MenuItem>
          ))}
        </Select>
      </FormControl>
      
      <Autocomplete
        disablePortal
        id="combo-box-faculty"
        name="faculty"
        options={faculties}
        style={{ marginTop: '20px' }}
        getOptionLabel={(option) => option.name}
        value={faculties.find((option) => option._id === formData.faculty) || null}
        onChange={(e, value) => handleChangeSubmit(e, value,'faculty')}
        renderInput={(params) => <TextField {...params} label="Faculty" />}
        size="small"
      />

      <TextField
        label="Consecutive Hours"
        name="consecutiveHours"
        value={formData.consecutiveHours}
        onChange={handleChange}
        fullWidth
        required
        style={{ marginTop: '20px' }}
        error={Boolean(errors.consecutiveHours)}
        helperText={errors.consecutiveHours}
        margin="dense"
        size="small"
      />

      <Autocomplete
        disablePortal
        id="combo-box-mentor"
        name="mentor"
        options={mentors}
        style={{ marginTop: '20px' }}
        getOptionLabel={(option) => option.name}
        value={mentors.find((option) => option._id === formData.mentor) || null}
        onChange={(e, value) => handleChangeSubmit(e, value,'mentor')}
        renderInput={(params) => <TextField {...params} label="Mentor" />}
        size="small"
      />

      <Autocomplete
        disablePortal
        id="combo-box-coordinator"
        name="coordinator"
        options={coordinator}
        style={{ marginTop: '20px' }}
        getOptionLabel={(option) => option.name}
        value={coordinator.find((option) => option._id === formData.coordinator) || null}
        onChange={(e, value) => handleChangeSubmit(e, value,'coordinator')}
        renderInput={(params) => <TextField {...params} label="Coordinator" />}
        size="small"
      />
      {id && formData.mode === 'Online' ? 
        <>
          <TextField
            label="Zoom Meeting Number"
            name="zoomMeetingNumber"
            value={formData.zoomMeetingNumber}
            onChange={handleChange}
            fullWidth
            required
            style={{ marginTop: '20px' }}
            error={Boolean(errors.zoomMeetingNumber)}
            helperText={errors.zoomMeetingNumber}
            margin="dense"
            size="small"
          />
          <TextField
            label="Zoom Meeting Password"
            name="zoomMeetingPassword"
            value={formData.zoomMeetingPassword}
            onChange={handleChange}
            fullWidth
            required
            style={{ marginTop: '20px' }}
            error={Boolean(errors.zoomMeetingPassword)}
            helperText={errors.zoomMeetingPassword}
            margin="dense"
            size="small"
          />
        </>
      : ''}
      {id ?
        <Grid container spacing={2}>
          <Grid item xs={10}>
            <Autocomplete
              id="combo-box-draft-batch"
              loading={loading}
              options={drafBatches}
              style={{ marginTop: '10px' }}
              getOptionLabel={(option) => option.name}
              value={drafBatches.find(batch => batch._id === formData.draftBatch)}
              onChange={(e, value) => handleChangeSubmit(e, value, 'draftBatch')}
              onInputChange={(e, value) => {
                  if(value !== searchBatch) {
                      handleSearchBatchOptionChange(e, value);
                  }
              }}
              size='small'
              renderInput={(params) => <TextField {...params} label="Batch *" size='small' />}
            />
          </Grid>
          <Grid item xs={2}>
            <Button type="button" onClick={addStudentFromDraft} variant="contained" color="primary" style={{ marginTop: '10px' }}>Add Students</Button>
          </Grid>
        </Grid>
      : ''}

      <div style={{ marginTop: '20px' }}>
        <Typography variant="h6">
            Elant Access 
        </Typography>
        <Autocomplete
            disablePortal
            id="goalBox"
            name="goal"
            required
            options={goal}
            style={{ marginTop: 15 }}
            getOptionLabel={(option) => option?.goal_name}  
            value={goal?.find(goal => goal._id === formData.elantGoal) || null}
            onChange={(e, value) => handleChangeGoal(value)} 
            renderInput={(params) => <TextField {...params} label="Goal" />}
            size="small"
            error={Boolean(errors.elantGoal)}
            helperText={errors.elantGoal}
        />
        <Autocomplete
            disablePortal
            id="paperBox"
            name="paper"
            required
            options={paper}
            style={{ marginTop: 15 }}
            getOptionLabel={(option) => option?.paper_name}
            value={paper?.find(paper => paper.paper_id === formData.elantPaper) || null}
            onChange={(e, value) => handleChangePaper(value)} 
            renderInput={(params) => <TextField {...params} label="Paper" />}
            size="small"
        />
        <Autocomplete
            disablePortal
            id="tutorBox"
            name="tutor"
            required
            options={tutor}
            style={{ marginTop: 15 }}
            getOptionLabel={(option) => option?.tutor_name}  
            value={tutor?.find(tutor => tutor.tutor_id === formData.elantTutor) || null}
            onChange={(e, value) => handleChangeTutor(value)} 
            renderInput={(params) => <TextField {...params} label="Tutor" />}
            size="small"
        />

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <FormControl className='gap-2 mb-8' fullWidth style={{ marginTop: "10px" }} size="small">
            <MobileDatePicker
              label="Elant Access Expiry"
              value={dayjs(formData.elantExpiry)}
              onChange={(date) => handleDateChange('elantExpiry', date)}
              sx={{ marginTop: 1 }}
              minDate={dayjs()}
              slotProps={{
                textField: {
                  size: 'small'
                }
              }}
            />
          </FormControl>
        </LocalizationProvider>
    </div>

      {(formData.paper && formData.mode && id) && <Students selectedStudents={selectedStudents} setSelectedStudents={onChangeStudent} paper={formData.paper} mode={formData.mode} batchId={id} limit={formData.limit} /> }

        <Materials materials={materials} setMaterials={setMaterials}/>

        {id && <Schdule schedule={schedule} getBatch={fetchbatchData} /> }

        {/* <Typography variant="h5" gutterBottom style={{ marginTop: '40px' }}>
          Checklist
        </Typography>
        <List>
          {checklist.map((item, index) => (
            <Card key={item.id} variant="outlined" style={{ marginBottom: 8 }}>
            <ListItem key={item.id} disablePadding>
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={item.checked}
                  tabIndex={-1}
                  disableRipple
                  onChange={() => handleChecklistChange(index)}
                  style={{marginLeft:5}}
                />
              </ListItemIcon>
              <ListItemText primary={item.id} />
            </ListItem>
            </Card>
          ))}
        </List> */}

        {(permissions.includes('readExam') && id) && (
          <ManageExam exams={exams} students={selectedStudents} batchReload={fetchbatchData} batchId={id} subject={formData.paper} />
        )}
        <Button type="submit" variant="contained" color="primary" style={{ marginTop: '20px' }}>
          {id ? 'Update batch' : 'Create batch'}
        </Button>
      </form>

      {(id && permissions.includes('readBatchActivityLogs')) && 
        <div style={{ marginTop: '2rem' }}>
          <Accordion defaultExpanded ={!id}>
            <AccordionSummary
              expandIcon={<ArrowDownwardIcon />}
              aria-controls="log-content"
              id="log-header"
            >
              <Typography>Activity Logs</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <ActivityLogs id={id} />
            </AccordionDetails>
          </Accordion>
        </div>
      }

    </div>
  );
};

export default CreatebatchForm;
